exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0bdb670e] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-0bdb670e] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n[data-v-0bdb670e] .el-dialog__body {\n  padding-bottom: 5px;\n}\n[data-v-0bdb670e] .el-calendar-table .el-calendar-day {\n  font-size: 20px;\n  text-align: center;\n  height: 65px;\n  background: lightgrey;\n}\n.mark[data-v-0bdb670e] {\n  font-size: 15px;\n  color: white;\n  background: #e74b4b;\n  height: 33px;\n  overflow: hidden;\n  line-height: 33px;\n  word-break: break-word;\n}\n", ""]);

// exports
